import { useMemo } from 'react';
import { FolderAssetType } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { ImagePreview } from '../components/image-preview';
import { VideoPreview } from '../components/video-preview';
import { ImageDetailsPanel } from '../components/image-panel';
import { VideoDetailsPanel } from '../components/video-panel';

const previewCompMap = {
  [FolderAssetType.Image]: ImagePreview,
  [FolderAssetType.Video]: VideoPreview,
};

const panelCompMap = {
  [FolderAssetType.Image]: ImageDetailsPanel,
  [FolderAssetType.Video]: VideoDetailsPanel,
};


export const usePreviewAndPanel = ({ folderAssetType }) => {
  const AssetPreview = useMemo(() => previewCompMap[folderAssetType], [folderAssetType]);
  const AssetDetailsPanel = useMemo(() => panelCompMap[folderAssetType], [folderAssetType]);

  return {
    AssetPreview,
    AssetDetailsPanel,
  };
};
